var render = function render(){var _vm=this,_c=_vm._self._c;return _c('index-page',{attrs:{"parentData":{ grid: _vm.grid, path: _vm.path, collection_path: _vm.collection_path, report_class: _vm.report_class, grid_key: _vm.grid_key, transition_key: _vm.transition_key, collection_type: _vm.collection_type, sti_type: _vm.sti_type, except_filters: _vm.except_filters }},on:{"set-loading":_vm.setLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }